import React, { useCallback } from 'react';
import { FieldProps } from 'formik';
import styled from 'styled-components';
import { SdirToggle } from '@sdir/sds';

interface FormToggleProps extends FieldProps {
  field: any;
  label: string;
  type: any;
  tab: number;
  checked: boolean;
  disabled: boolean;
  className?: string;
  value?: string | number | Date | undefined;
  onChangeCallback?: (val: any) => void;
  novalidate?: boolean;
}

const FormToggle: React.FC<FormToggleProps> = ({
  field,
  label,
  type,
  tab,
  disabled,
  className = '',
  value,
  checked,
  onChangeCallback,
  form,
  novalidate,
}) => {
  const handleChange = useCallback(
    (val: string, e: any) => {
      if (form?.setFieldValue) form.setFieldValue(field.name, !checked);
      if (onChangeCallback) onChangeCallback(!checked);
    },
    [form, field, onChangeCallback, checked]
  );

  const meta = form.getFieldMeta(field.name);
  return (
    <ToggleWrapper className={className}>
      <SdirToggle
        {...field}
        disabled={disabled}
        id={field.name}
        tabIndex={tab}
        type={type}
        name={field.name}
        invalid={!!(form.errors[field.name] && form.touched[field.name] && !disabled)}
        checked={field.value || value || ''}
        novalidate={novalidate}
        error={meta && meta.touched && meta.error}
        aria-label={label}
        title={label}
        onClick={handleChange}
      />
    </ToggleWrapper>
  );
};

export default FormToggle;

const ToggleWrapper = styled.div`
  label {
    margin-left: 30px;
  }
`;
